import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import './index.css';

import { BrowserRouter , Switch ,Route,Redirect} from 'react-router-dom';
import { Provider } from 'react-redux'
import {store,persistor} from './redux/store';
import { PersistGate } from 'redux-persist/integration/react'
import Login from './screens/login/login'
import ForgetPassword from './screens/forgetPassword/forgetPassword'
import Splash from './screens/splash/splash'
import UserInfo from './screens/user info/user info'
import User from './screens/user/user'
import Admins from './screens/admin/admin'
import Search from './screens/search/search'
import Questions from './screens/question/question';
import QuestionsInfo from './screens/question info/question info';
import addQuestions from './screens/add question/add question';
import AddUser from './screens/add user/add user'
import setting from './screens/setting/setting';
import contactus from './screens/contactus/contactus';
import sendNotifs from './screens/send notifs/send notifs';
import Home from './screens/home/Home';
import About from './screens/about/about';
import Locations from './screens/location/location';
import LocationInfo from './screens/location info/location info';
import AddLocation from './screens/add location/add location';
import Categories from './screens/categories/categories';
import CategoryInfo from './screens/category info/category info';
import AddCategory from './screens/add category/add category';
import Deals from './screens/deals/deals';
import DealInfo from './screens/deal info/deal info';
import Properties from './screens/properties/properties';
import PropertyInfo from './screens/property info/property info';
import AddProperty from './screens/add property/add property';
import projects from './screens/project/project';
import projectInfo from './screens/project info/project info';
import AddProject from './screens/add project/add project';
import Countries from './screens/countries/countries';
import CountryInfo from './screens/country info/country info'
import CityInfo from './screens/city info/city info'
import AddCountry from './screens/add country/add country'
import Employee from './screens/employee/employee';
import EmployeeInfo from './screens/employee info/employee info'
import AddEmployee from './screens/add employee/add employee'
import views from './screens/views/views';
import viewsInfo from './screens/views info/views info'
import Permissions from './screens/permission/permission';
import PermissionInfo from './screens/permission info/permission info'
import AddPermission from './screens/add permission/add permission'
import Supervisors from './screens/supervisor/supervisor';

import Clients from './screens/clients/clients';
import ClientInfo from './screens/client info/client info';
//import AddClient from './screens/add client/add client';
import Guidelines from './screens/guideline/guideline';
import GuidelineInfo from './screens/guideline info/guideline info'
import AddGuideline from './screens/add guideline/add guideline'

import Companies from './screens/company/company';
import CompanyInfo from './screens/company info/company info'
import AddCompany from './screens/add company/add company'
import Anoncements from './screens/anoncement/anoncement';
import AnoncementInfo from './screens/anoncement info/anoncement info'
import AddAnoncement from './screens/add anoncement/add anoncement'
import NewLaunches from './screens/newLaunches/newLaunches';
import NewLaunchInfo from './screens/newLaunch info/newLaunch info'
import AddNewLaunch from './screens/add newLaunch/add newLaunch'
import Prizes from './screens/prize/prize';
import PrizeInfo from './screens/prize info/prize info'
import AddPrize from './screens/add prize/add prize'
import benefitInfo from './screens/benefit info/benefit  info';
import benefit from './screens/benefit/benefit';
import addBenefit from './screens/add benefit/add benefit';
import sharedProperty from './screens/sharedProperty/sharedProperty';
import sharedPropertyInfo from './screens/sharedProperty info/sharedProperty info';
import addSharedProperty from './screens/add sharedProperty/add sharedProperty';
import vendors from './screens/vendor/vendor';
import vendorInfo from './screens/vendor info/vendor info';
import addVendor from './screens/add vendor/add vendor';
import campaigns from './screens/campaign/campaign';
import campaignInfo from './screens/campaign info/campaign info';
import addCampaign from './screens/add campaign/add campaign';
import leads from './screens/lead/lead';
import leadInfo from './screens/lead info/lead info';
import addLead from './screens/add lead/add lead';
import meetings from './screens/meeting/meeting';
import meetingInfo from './screens/meeting info/meeting info'
// Define App inline


ReactDOM.render(
  
<Provider store={store}>
  <PersistGate loading={null} persistor={persistor}>
    <BrowserRouter >
      <Switch>
        <Route path={"/Login"} component={Login}/> 
        <Route exact path={"/"} component={Splash}/> 
        <Route path={"/forgetPassword"} component={ForgetPassword}/>
        <App path={'/meetings'} component={meetings}/>
        <App path={'/meetingInfo'} component={meetingInfo}/>
        <App path={'/leads'} component={leads}/>
        <App path={'/leadInfo'} component={leadInfo}/>
        <App path={'/addLead'} component={addLead}/>
        <App path={'/campaigns'} component={campaigns}/>
        <App path={'/campaignInfo'} component={campaignInfo}/>
        <App path={'/addCampaign'} component={addCampaign}/>
        <App path={'/vendors'} component={vendors}/>
        <App path={'/vendorInfo'} component={vendorInfo}/>
        <App path={'/addVendor'} component={addVendor}/>
        <App path={'/sharedProperties'} component={sharedProperty}/>
        <App path={'/sharedPropertyInfo'} component={sharedPropertyInfo}/>
        <App path={'/addSharedProperty'} component={addSharedProperty}/>
        <App path={'/BenefitInfo'} component={benefitInfo}/> 
        <App path={'/Benefits'} component={benefit}/> 
        <App path={'/AddBenefit'} component={addBenefit}/> 

        <App path={'/CompanyInfo'} component={CompanyInfo}/> 
        <App path={'/Companies'} component={Companies}/> 
        <App path={'/AddCompany'} component={AddCompany}/> 
        <App path={'/PrizeInfo'} component={PrizeInfo}/> 
        <App path={'/Prizes'} component={Prizes}/> 
        <App path={'/AddPrize'} component={AddPrize}/> 
        <App path={'/AnoncementInfo'} component={AnoncementInfo}/> 
        <App path={'/Anoncements'} component={Anoncements}/> 
        <App path={'/AddAnoncement'} component={AddAnoncement}/> 
        <App path={'/NewLaunchInfo'} component={NewLaunchInfo}/> 
        <App path={'/NewLaunches'} component={NewLaunches}/> 
        <App path={'/AddNewLaunch'} component={AddNewLaunch}/> 

        <App path={'/GuidelineInfo'} component={GuidelineInfo}/> 
        <App path={'/Guidelines'} component={Guidelines}/> 
        <App path={'/AddGuideline'} component={AddGuideline}/> 
        <App path={'/views'} component={views}/>
        <App path={'/Supervisors'} component={Supervisors}/> 
        <App path={'/viewsInfo'} component={viewsInfo}/>
        <App path={'/PermissionInfo'} component={PermissionInfo}/> 
        <App path={'/Permissions'} component={Permissions}/> 
        <App path={'/AddPermission'} component={AddPermission}/> 
        <App path={'/employees'} component={Employee}/>
        <App path={'/employeeInfo'} component={EmployeeInfo}/>
        <App path={'/AddEmployee'} component={AddEmployee}/>
        <App path={'/Countries'} component={Countries}/>
        <App path={'/CountryInfo'} component={CountryInfo}/>
        <App path={'/CityInfo'} component={CityInfo}/>
        <App path={'/AddCountry'} component={AddCountry}/>
        <App path={'/Properties'} component={Properties}/> 
        <App path={'/propertyInfo'} component={PropertyInfo}/> 
        <App path={'/addProperty'} component={AddProperty}/> 
        <App path={'/projects'} component={projects}/> 
        <App path={'/projectInfo'} component={projectInfo}/> 
        <App path={'/AddProject'} component={AddProject}/> 
        <App path={'/Deals'} component={Deals}/> 
        <App path={'/DealInfo'} component={DealInfo}/> 
        <App path={'/Clients'} component={Clients}/> 
        <App path={'/ClientInfo'} component={ClientInfo}/> 
        {/* <App path={'/addClient'} component={AddClient}/>  */}
        <App path={'/LocationInfo'} component={LocationInfo}/> 
        <App path={'/Locations'} component={Locations}/> 
        <App path={'/AddLocation'} component={AddLocation}/>
        <App path={'/Categories'} component={Categories}/> 
        <App path={'/CategoryInfo'} component={CategoryInfo}/> 
        <App path={'/AddCategory'} component={AddCategory}/>  
        <App path={'/Questions'} component={Questions}/>
        <App path={'/questionInfo'} component={QuestionsInfo}/>
        <App path={'/AddQuestion'} component={addQuestions}/>
        <App path={'/Search'} component={Search}/>
        <App path={'/about'} component={About}/>
        <App path={'/Home'} component={Home}/>
        <App path={'/users'} component={User}/>
        <App path={'/Admins'} component={Admins}/>
        <App path={'/userInfo'} component={UserInfo}/>
        <App path={'/addUser'} component={AddUser}/>
        <App path={'/Setting'} component={setting}/>
        <App path={'/ContactUs'} component={contactus}/>
        <App path={'/SendNotifs'} component={sendNotifs}/>
        
      </Switch>
    </BrowserRouter>
  </PersistGate>
</Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
